import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { formatDate } from '@repo/utils/time'

// if you pass in an error object, it will extract the relevant information and open an email client with a pre-filled email
export const openSupportEmail = (errorObject = {}) => {
  const { error, status, statusText, message, stack, cause } = errorObject
  const statusCodeStr = status || cause?.status || ''
  const statusTextStr = statusText || cause?.statusText || ''
  const messageStr = message || error?.message || ''

  const { userId, emailAddress } = useAuthenticationStore.getState()
  const { companyCode, databaseSuffix } = useGlobalSettingsStore.getState()

  const buildNumber = import.meta.env.VITE_SPA_OSPREY_BUILD_NUMBER || ''
  const branch = import.meta.env.VITE_SPA_OSPREY_GIT_BRANCH || ''
  const commit = import.meta.env.VITE_SPA_OSPREY_GIT_COMMIT_HASH || ''
  const environment = import.meta.env.VITE_SPA_OSPREY_ENV || 'dev'
  const resolution = `${window.visualViewport.width}x${window.visualViewport.height}`

  const str = `Dear Osprey Support Team

** PLEASE ENTER YOUR MESSAGE HERE AND ATTACH ANY RELEVANT SCREENSHOTS **


========================

Helpful details have been included below to assist the support team with troubleshooting. You are welcome to remove them if you prefer not to share these details.

USER ID: ${userId || ''}
USER EMAIL: ${emailAddress || ''}
COMPANY: ${companyCode || ''}
DATE: ${formatDate(new Date(), 'EEE d MMM yyyy, HH:mm:ss')}

URL: ${window.location.href}
STATUS: ${statusCodeStr || ''}${statusCodeStr && statusTextStr ? ' | ' : ''}${statusTextStr || ''}
ERROR: ${messageStr || ''}

ENV: ${environment || ''}
BUILD: ${buildNumber || ''}
BRANCH: ${branch || ''}
COMMIT: ${commit || ''}
DBSUFFIX: ${databaseSuffix || ''}
VIEWPORT: ${resolution || ''}
USER AGENT: ${navigator.userAgent || ''}

STACK TRACE: ${stack || ''}

========================
`

  const encodedString = encodeURIComponent(str)

  window.open(
    `mailto:support@ospreyapproach.com?subject=Osprey%20Approach%20support%20request&body=${encodedString}`,
    '_blank'
  )
}
